:host {
  display: flex;
  width: 100%;
}

.step-item-list {
  display: flex;
  margin: 0;
  padding: 0;
}

:host(.ic-stepper-default:not(.ic-stepper-aligned-left)) .step-item-list {
  flex: auto;
}

:host(.ic-stepper-compact) ul ::slotted(ic-step) {
  display: none;
}

:host(.ic-stepper-compact) ul ::slotted(ic-step.show) {
  display: flex;
}

:host(.ic-stepper-compact) ul ::slotted(ic-step.hide) {
  display: none;
  opacity: 0;
  visibility: hidden;
}
